import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { AlertService, MessageDetail } from './alert.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-alert',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.scss'
})
export class AlertComponent implements OnInit, AfterViewInit {

  @ViewChild('alertToast') alertToast: any;
 
  durationInSeconds: number = 2;
  showErrorAlert?: Boolean = false;
  showMessageAlert: Boolean = false;
  errors!: MessageDetail[];
  messages!: string[];

  title: string = "";
  modal: boolean = true;
  autoClose: boolean = false;

 constructor(private alertService: AlertService) {
    this.initializeErrors();
  }
 

  ngOnInit(): void {
  }
  ngAfterViewInit(): void {
  }
  
 
  private initializeErrors() {
    this.alertService
      .getErrors()
      .pipe()
      .subscribe((errors) => {
        this.showErrorAlert = true;
        this.showMessageAlert = false;
        if (errors) {
          this.errors = errors;
        }

        this.modal = true;
        this.autoClose = this.alertService.isAutoClose();
        this.title = this.alertService.getTitle();
        this.alertToast.nativeElement.classList.add('show');
        this.checkIsAutoclose();
      });
  }

  private checkIsAutoclose() {
    if (this.autoClose) {
      setTimeout(() => {
        this.title = "";
        this.showErrorAlert = false;
        this.showMessageAlert = false;
        this.alertToast.nativeElement.classList.remove('show');
      }, this.durationInSeconds * 1000);
    }
  }
  
  clickHideErrorModalAlert() {
    this.showErrorAlert = false;
  }
 
}